import styles from './SearchButton.css';

export const SearchButton: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className={styles['container']} data-testid="SearchButton">
      {children}
    </div>
  );
};
